import React from 'react';
import { XIcon } from 'lucide-react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function ProblemSection() {
  const {
    ref: problemRef,
    isVisible: problemVisible
  } = useScrollReveal();
  const {
    ref: failedRef,
    isVisible: failedVisible
  } = useScrollReveal();
  return <section className="relative py-24 px-6 z-10 bg-night-900" data-id="element-154">
      <div className="max-w-4xl mx-auto" data-id="element-155">
        {/* The Problem */}
        <div ref={problemRef} className={`mb-24 section-reveal ${problemVisible ? 'visible' : ''}`} data-id="element-156">
          <h3 className="text-3xl md:text-4xl font-heading font-bold text-cream-100 mb-8 text-center" data-id="element-157">
            ¿Qué está pasando realmente?
          </h3>
          <div className="space-y-6 text-lg text-cream-200 leading-relaxed max-w-3xl mx-auto" data-id="element-158">
            <p data-id="element-159">
              A partir de los 50 años, el insomnio no es solo "falta de sueño".
              Es un{' '}
              <span className="text-gold-400 font-semibold" data-id="element-160">
                exceso de alerta
              </span>
              . Tu sistema nervioso está atascado en el modo de "supervivencia"
              debido a los cambios hormonales y el peso de las
              responsabilidades.
            </p>
            <p data-id="element-161">
              Tu cuerpo quiere descansar, pero tu cerebro ha olvidado cómo
              aterrizar. El resultado es el{' '}
              <span className="text-gold-400 font-semibold italic" data-id="element-162">
                "Silencio que Grita"
              </span>
              : una habitación oscura llena de ruidos mentales que no te dejan
              en paz.
            </p>
          </div>
        </div>

        {/* Why What You Tried Didn't Work */}
        <div ref={failedRef} className={`section-reveal ${failedVisible ? 'visible' : ''}`} data-id="element-163">
          <h3 className="text-2xl md:text-3xl font-heading font-bold text-cream-100 mb-10 text-center" data-id="element-164">
            Por qué lo que has intentado no funciona
          </h3>

          <div className="grid gap-6 md:grid-cols-3" data-id="element-165">
            <div className="glass-card p-8 rounded-2xl flex flex-col items-center text-center" data-id="element-166">
              <div className="w-12 h-12 rounded-full bg-red-900/20 flex items-center justify-center mb-6" data-id="element-167">
                <XIcon className="w-6 h-6 text-red-400/80" data-id="element-168" />
              </div>
              <h4 className="text-xl font-heading text-cream-100 mb-4 line-through decoration-red-400/50 decoration-2" data-id="element-169">
                Sedantes Químicos
              </h4>
              <p className="text-cream-200/80 text-base" data-id="element-170">
                Te dejan aturdida y "borracha" por la mañana, sin reparar
                realmente tu cuerpo.
              </p>
            </div>

            <div className="glass-card p-8 rounded-2xl flex flex-col items-center text-center" data-id="element-171">
              <div className="w-12 h-12 rounded-full bg-red-900/20 flex items-center justify-center mb-6" data-id="element-172">
                <XIcon className="w-6 h-6 text-red-400/80" data-id="element-173" />
              </div>
              <h4 className="text-xl font-heading text-cream-100 mb-4 line-through decoration-red-400/50 decoration-2" data-id="element-174">
                Infusiones Calientes
              </h4>
              <p className="text-cream-200/80 text-base" data-id="element-175">
                Son agradables, pero no tienen el poder de apagar los
                pensamientos intrusivos.
              </p>
            </div>

            <div className="glass-card p-8 rounded-2xl flex flex-col items-center text-center" data-id="element-176">
              <div className="w-12 h-12 rounded-full bg-red-900/20 flex items-center justify-center mb-6" data-id="element-177">
                <XIcon className="w-6 h-6 text-red-400/80" data-id="element-178" />
              </div>
              <h4 className="text-xl font-heading text-cream-100 mb-4 line-through decoration-red-400/50 decoration-2" data-id="element-179">
                Contar Ovejas
              </h4>
              <p className="text-cream-200/80 text-base" data-id="element-180">
                Ignora la raíz del problema: la química del estrés (cortisol)
                que recorre tus venas.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}